const AdminHome = () => {
  return (
    <div>
      <h1>Admin Home</h1>
    </div>
  );
};

export default AdminHome;
